import { useSelector } from 'react-redux';

export const useMediaServerSelector = () => {
  const isScreenshared = useSelector((state) => state.mediaServer.screenshare.isShared);

  return { isScreenshared };
};
